import React from "react";

export interface IHeaderProps {
  title: string;
}

const Header: React.FC<IHeaderProps> = ({ title }): React.ReactElement => (
  <h1 className="f1">{title}</h1>
);
export default React.memo(Header);
